import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Select from "react-select";


import './Direction.css'
import { useTranslation } from "react-i18next";

const Direction = () => {
    const { t } = useTranslation();

    const [ship, setShip] = useState([])

    useEffect(() => {
        let shipIdsValues = localStorage.getItem('shipIds')
        
        if (shipIdsValues) {

            let shipIds = shipIdsValues.split(',')
            let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
            if (xsrfToken) {
                xsrfToken = xsrfToken.split('=')[1]
            }
            let token = document.cookie.split('; ').find(row => row.startsWith('token'));
            if (token) {
                token = token.split('=')[1]
            }

            fetch(`${process.env.REACT_APP_API_URL}/api/ship/download/`+shipIdsValues + '/direction', {
                method: 'GET',
                headers: {
                    'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                    'Authorization': 'Bearer '+ decodeURIComponent(token),
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
            })
            .then(res => res.json())
            .then(data => {
                setShip(data)
            })
            .catch(err => {
                console.log(err)
            })
        } else {
            window.close()
        }
    }, [])

    const shipmentType = {
        2: t('direction.how1'),
        3: t('direction.how2'),
        4: t('direction.how3'),
    }

    const CreateCards = ({sihpIndex, cards}) => {
        return (
            <>
                {cards.map((item, index) => {
                    return (
                        <tr key={"ship" + sihpIndex + "-" + "card" + index}>
                            <td>{item.card_name}</td>
                            <td>{item.package_name}</td>
                            <td>{item.package_type_name}</td>
                            <td>{item.count}</td>
                        </tr>
                    )
                })}
            </>
        )
    }

    const CreateDirections = ({ships}) => {

        if (ships.length === 0) return null;

        return (
            <>
                {ships.map((item, index) => {
                    return (
                        <section className="page" key={"direction" + index}>
                            <div className="direction-title">
                                <h1>{t('direction.title')}</h1>
                            </div>
                            <div className="direction-content">
                                <table className="direction-table-1">
                                    <thead>
                                        <tr>
                                            <th>{t('direction.direction')}</th>
                                            <th>{t('direction.id')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                〒{item.client_address['postal_code'].slice(0, 3)}-{item.client_address['postal_code'].slice(3)} {item.client_address['prefecture']}{item.client_address['address']}{item.client_address['address2'] ? ` ${item.client_address['address2']}` : ''}<br/>
                                                {item.client_name} {t('direction.mr')}
                                            </td>
                                            <td>{item.id}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className="direction-table-2">
                                    <thead>
                                        <tr>
                                            <th>{t('direction.day')}</th>
                                            <th>{t('direction.how')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{item.order_date}</td>
                                            <td>
                                                {item.shipment_type &&
                                                    shipmentType[item.shipment_type]
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className="direction-table-3">
                                    <thead>
                                        <tr>
                                            <th>{t('direction.name')}</th>
                                            <th>{t('direction.oripa')}</th>
                                            <th>{t('direction.kind')}</th>
                                            <th>{t('direction.num')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <CreateCards shipIndex={index} cards={item.shipment_cards}/>
                                    </tbody>
                                </table>
                                <table className="direction-table-4">
                                    <thead>
                                        <tr>
                                            <th>{t('direction.remarks')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{item.note}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    )
                })}
            </>
        )
    }

    return (
        <>
            <div className="print-button">
                <button onClick={() => window.print()}>{t('direction.print')}</button>
                <button onClick={() => window.close()}>{t('direction.close')}</button>
            </div>
            <CreateDirections ships={ship}/>
        </>
    )
}

export default Direction